import { CardSkeleton, DashCard } from "../DashboardCards";
import { COLORS, MES_LABELS } from "../../configs/config";
import { Box } from "@mui/material";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { DarkTip } from "../DashboardTooltip";
import { ChartLegend } from "./ChartLegend";

export const ConsumoChart = ({ data, loading }) => {
    if (loading) return <CardSkeleton height={160} />;

    const years = data?.map((y) => y.year) ?? [];

    const merged = MES_LABELS.map((mes, idx) => {
        const entry = { mes };
        years.forEach((yr) => {
            const found = data
                ?.find((y) => y.year === yr)
                ?.data?.find((m) => m.month === idx + 1);
            entry[`y${yr}`] = found?.average ?? null;
        });
        return entry;
    });

    return (
        <DashCard title="Consumo médio mensal / funcionário" tag={years.join(" vs ")}>
            <ChartLegend items={years.map((yr, i) => ({
                color: i === 0 ? COLORS.chartLine1 : COLORS.chartDim,
                label: String(yr),
                dash: i > 0,
            }))} />
            <Box sx={{ position: "relative", height: 160 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={merged} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
                        <defs>
                            {years.map((yr, i) => (
                                <linearGradient key={yr} id={`grad${yr}`} x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%"  stopColor={i === 0 ? COLORS.chartLine1 : COLORS.chartDim} stopOpacity={0.2} />
                                    <stop offset="95%" stopColor={i === 0 ? COLORS.chartLine1 : COLORS.chartDim} stopOpacity={0.01} />
                                </linearGradient>
                            ))}
                        </defs>
                        <XAxis
                            dataKey="mes"
                            tick={{ fill: COLORS.tDim, fontSize: 9 }}
                            axisLine={{ stroke: COLORS.border }}
                            tickLine={false}
                        />
                        <YAxis
                            tick={{ fill: COLORS.tDim, fontSize: 9 }}
                            axisLine={false}
                            tickLine={false}
                            domain={[0, "auto"]}
                        />
                        <Tooltip content={<DarkTip />} />
                        {years.map((yr, i) => (
                            <Area
                                key={yr}
                                type="monotone"
                                dataKey={`y${yr}`}
                                name={String(yr)}
                                stroke={i === 0 ? COLORS.chartLine1 : COLORS.chartDim}
                                strokeWidth={i === 0 ? 2 : 1.5}
                                strokeDasharray={i > 0 ? "4 4" : undefined}
                                fill={i === 0 ? `url(#grad${yr})` : "transparent"}
                                dot={i === 0 ? { fill: COLORS.chartLine1, r: 3 } : false}
                                connectNulls={false}
                            />
                        ))}
                    </AreaChart>
                </ResponsiveContainer>
            </Box>
        </DashCard>
    );
};